/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Resend_Code_LabelInputs */

const en_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

const de_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code erneut senden`)
};

const pt_br2_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

const tr_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodu yeniden gönder`)
};

const zh_cn2_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新发送验证码`)
};

const zh_hk2_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新傳送驗證碼`)
};

const ko_kr2_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드 다시 보내기`)
};

const ru_ru2_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить код ещё раз`)
};

const es_419_login_page_resend_code_label = /** @type {(inputs: Login_Page_Resend_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Login_Page_Resend_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_resend_code_label = /** @type {((inputs?: Login_Page_Resend_Code_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Resend_Code_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_resend_code_label(inputs)
	if (locale === "de") return de_login_page_resend_code_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_resend_code_label(inputs)
	if (locale === "tr") return tr_login_page_resend_code_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_resend_code_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_resend_code_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_resend_code_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_resend_code_label(inputs)
	return es_419_login_page_resend_code_label(inputs)
});